// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2v-5B","container":"styles_container__3j_ke","title":"styles_title__2rZT0","wrapper":"styles_wrapper__3S94D","answer":"styles_answer__3iry2"};